import {
  COLUMNS_CHANGE_EVENT,
  hiddenColumns,
  setColumnHidden,
  showAllColumns,
} from "../candidate_column_order";

const DD_SELECTOR = "[data-cols-dd]";
const TABLE_SELECTOR = "table[data-candidates-grid][data-columns-url]";

let bound = false;

const phoneTable = (): HTMLTableElement | null => document.querySelector<HTMLTableElement>(TABLE_SELECTOR);

const escHtml = (s: string): string => {
  const d = document.createElement("div");
  d.textContent = s;
  return d.innerHTML;
};

function columnLabel(th: HTMLElement): string {
  return th.dataset.colLabel || th.getAttribute("title") || (th.textContent || "").trim();
}

function render(): void {
  const dd = document.querySelector<HTMLElement>(DD_SELECTOR);
  const table = phoneTable();
  const menu = dd?.querySelector<HTMLElement>("[data-cols-menu]");
  const label = dd?.querySelector<HTMLElement>("[data-cols-label]");
  const head = table?.tHead?.rows[0];
  if (!dd || !menu || !label || !table || !head) return;

  const hidden = hiddenColumns(table);
  const items = Array.from(head.cells).map((th) => {
    const key = th.dataset.col || "";
    const locked = !key;
    const shown = locked || !hidden.includes(key);
    const classes = ["dd-opt", shown ? "active" : "", locked ? "locked" : ""].filter(Boolean).join(" ");
    return (
      `<div class="${classes}" role="menuitemcheckbox" aria-checked="${shown}"` +
      `${locked ? ' aria-disabled="true"' : ` data-cols-key="${escHtml(key)}" tabindex="0"`}>` +
      `<span class="tick"></span>${escHtml(columnLabel(th as HTMLElement))}</div>`
    );
  });

  menu.innerHTML =
    items.join("") +
    '<div class="dd-menu-foot"><button type="button" class="btn btn-sm btn-ghost" data-cols-show-all>Show all</button></div>';
  label.textContent = hidden.length ? `${hidden.length} hidden` : "";
  dd.querySelector("[data-cols-trigger]")?.classList.toggle("has-val", hidden.length > 0);
}

function setOpen(dd: HTMLElement, open: boolean): void {
  dd.classList.toggle("open", open);
  dd.querySelector("[data-cols-trigger]")?.setAttribute("aria-expanded", String(open));
}

function toggleKey(key: string): void {
  const table = phoneTable();
  if (!table || !key) return;
  setColumnHidden(table, key, !hiddenColumns(table).includes(key));
}

function onClick(event: MouseEvent): void {
  const target = event.target as HTMLElement | null;
  const dd = document.querySelector<HTMLElement>(DD_SELECTOR);
  if (!target || !dd) return;

  if (!target.closest(DD_SELECTOR)) {
    setOpen(dd, false);
    return;
  }

  if (target.closest("[data-cols-trigger]")) {
    render();
    setOpen(dd, !dd.classList.contains("open"));
    return;
  }

  if (target.closest("[data-cols-show-all]")) {
    const table = phoneTable();
    if (table) showAllColumns(table);
    return;
  }

  const option = target.closest<HTMLElement>("[data-cols-key]");
  if (option) toggleKey(option.dataset.colsKey || "");
}

function onKeydown(event: KeyboardEvent): void {
  const dd = document.querySelector<HTMLElement>(DD_SELECTOR);
  if (!dd || !dd.classList.contains("open")) return;

  if (event.key === "Escape") {
    setOpen(dd, false);
    return;
  }

  const option = (event.target as HTMLElement | null)?.closest<HTMLElement>("[data-cols-key]");
  if (option && (event.key === "Enter" || event.key === " ")) {
    event.preventDefault();
    toggleKey(option.dataset.colsKey || "");
  }
}

export function initHideColumnsMenu(): void {
  if (!document.querySelector(DD_SELECTOR)) return;

  if (!bound) {
    bound = true;
    document.addEventListener("click", onClick);
    document.addEventListener("keydown", onKeydown);
    // A header control, Reset columns or a menu tick changed the layout: repaint the checklist.
    document.addEventListener(COLUMNS_CHANGE_EVENT, render);
  }
  render();
}
